import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { useIsLoggedOutDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import { DISCOVER_PAGE_STORE_TYPE_SECTION_250730 } from "@faire/web-api--source/indigofair/settings/DISCOVER_PAGE_STORE_TYPE_SECTION_250730";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";

export const useSettingEnableLoggedOutDiscoverStoreTypeSection = () => {
  const setting = useSetting(
    DISCOVER_PAGE_STORE_TYPE_SECTION_250730,
    IThreeVariantXP.Bucket.CONTROL
  );

  const isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();

  return isLoggedOutDiscoverPage ? setting : IThreeVariantXP.Bucket.CONTROL;
};
